const CircleCheck = ({ title, ...props }) => (
  <svg {...props} viewBox="0 0 128 128" aria-hidden="true" focusable="false">
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <circle fill="#34B579" cx={64} cy={64} r={64} />
      <path
        d="M54.125 91.71c-.976.98-4.294.98-5.27 0-.039-.055-24.197-25.137-24.197-25.137-.987-.99-1.032-3.398.876-5.313 1.908-1.915 4.31-1.86 5.296-.87l20.694 22.498 46.091-47.973c.974-.976 3.158-1.385 5.337.664s1.776 4.507.8 5.486L54.125 91.711z"
        fill="#FFFFFF"
      />
    </g>
  </svg>
);

export default CircleCheck;
